import animation from '@helpers/animation';
import brand from '@helpers/brand';
import { GalleryIconStyles } from '@stories/Elements/Media/GalleryIcon/GalleryIcon.styles';
import { Grid } from '@stories/Settings/Grids/Grid.styles';
import styled, { keyframes } from 'styled-components';

const MediaGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  ${Grid.defaultGap};
`;

const MediaItem = styled.div`
  aspect-ratio: 1;
  position: relative;
  grid-column: span 1;
  background-color: ${brand.white};

  &[data-is-single='true'] {
    grid-column: 1 / -1;
  }

  img,
  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;
  }
`;

const YoutubeImageScaler = styled.div`
  overflow: hidden;
  aspect-ratio: 1;
  position: relative;

  img {
    transform: scale(1.35);
  }
`;

const overlayFadeKeyframes = keyframes`
0% {
  filter: contrast(1);
  opacity: 0;
}
100% {
  opacity: 0.4;
  filter: contrast(0.4);
}
`;

const overlayContentFadeKeyframes = keyframes`
0% {
  opacity: 0;
}
100% {
  opacity:1;
}
`;

const MediaItemOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${brand.white};
  cursor: pointer;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${brand.black};
    opacity: 0;
    z-index: -1;
    animation: ${overlayFadeKeyframes} 750ms 750ms forwards ease;
  }

  > * {
    opacity: 0;

    animation: ${overlayContentFadeKeyframes} 750ms 1000ms forwards ease;
  }
`;

const MediaItemIcon = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  user-select: none;
  cursor: pointer;
  background-color: rgba(${brand.red.baseRgb}, 0);
  transition: background 500ms ease;

  ${GalleryIconStyles.Container} {
    position: absolute;
    top: 8px;
    left: 8px;

    ${GalleryIconStyles.Count} {
      transition: background 500ms ease, color 500ms ease;
    }

    svg {
      width: 42px;
      height: 42px;
      z-index: 2;
      transform: scale(1);
      transition: transform 500ms ease, color 500ms ease;
      color: ${brand.red.base};
    }
  }

  > svg {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 70px;
    height: 70px;
    z-index: 2;
    transform: translate(-50%, -50%) scale(1);
    transition: transform 500ms ease, opacity 275ms ${animation.easeInOutCubic};
    color: ${brand.white};
    opacity: 0;
  }

  &:hover {
    background-color: rgba(${brand.red.baseRgb}, 0.6);

    ${GalleryIconStyles.Container} {
      ${GalleryIconStyles.Count} {
        background: ${brand.white};
        color: ${brand.red.base};
      }

      svg {
        color: ${brand.white};
      }
    }

    > svg {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1.25);
    }
  }
`;

const LightboxLoader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
`;

export const ProductMediaLayoutStyles = {
  MediaGrid,
  MediaItem,
  MediaItemOverlay,
  MediaItemIcon,
  YoutubeImageScaler,
  LightboxLoader,
};
